module.exports = __webpack_public_path__ + "static/crehana-d5849546d67cf5d7d9845aedd4c776fa.png";